import { getStepResources } from "@/features/adapters/model";
import type { AdapterBlockProps } from "@/features/adapters/stepTypes";
import { AdapterStepHeader } from "./AdapterStepHeader";
import { stateVariant, statusLabel } from "./statusPresentation";

export function ConnectionStepHeader({ step, shell }: AdapterBlockProps<"connection">) {
  const state = shell.stepInspection?.state ?? "missing";
  return <AdapterStepHeader
    title={getStepResources(step, "connection")[0]?.resource.name ?? step.label}
    variant={stateVariant[state]}
    status={statusLabel(state)}
  />;
}

export function ConnectorStepHeader({ step, shell }: AdapterBlockProps<"connector">) {
  const state = shell.stepInspection?.state ?? "missing";
  return <AdapterStepHeader
    title={getStepResources(step, "connector")[0]?.resource.name ?? step.label}
    variant={stateVariant[state]}
    status={statusLabel(state)}
  />;
}
